import { render, staticRenderFns } from "./FacebookPageAdPostCard.vue?vue&type=template&id=f283fa1a"
import script from "./FacebookPageAdPostCard.vue?vue&type=script&lang=js"
export * from "./FacebookPageAdPostCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports